/**
 * * Conditionally render a wrapper component based on a condition
 * @param {Object} props
 * @param {boolean} props.condition
 * @param {Function} props.wrapper
 * @param {React.ReactNode} props.children
 * @returns {React.ReactElement} wrapped children if condition is true, else children
 */
export default function ConditionalWrapper({ condition, wrapper, children }) {
  return condition ? wrapper(children) : children;
}
